import http from '@/config/api';
import router from '@/router';

export default {
  async getHistories({ commit }, params) {
    const directory = params?.directory || router.currentRoute.value?.params.directory;
    const monitoringId = router.currentRoute.value?.params.monitoringId;
    const urlApi = `event/${directory}/history` + (monitoringId ? `/${monitoringId}` : '');
    const urlPoint = `event/${directory}/point-history`;
    await http.get(['PointHistoryAll', 'PointHistoryBuy', 'PointHistoryUse'].includes(router.currentRoute.value.name) ? urlPoint : urlApi, {
      params: {
        ...params,
        ...(
          router.currentRoute.value.name === 'PointHistoryBuy' ? { action: 'Get' } : {}
        ),
        ...(
          router.currentRoute.value.name === 'PointHistoryUse' ? { action: 'Use' } : {}
        )
      }
    }).then((response) => {
      if (params?.isWithoutLoadmore) {
        commit('SET_HISTORIES', response?.data);
      } else {
        commit('ADD_HISTORIES', response?.data);
      }
    });
  },
  async resetState({ commit }) {
    commit('RESET_STATE');
  },
  async downloadMemoCsv(_, params) {
    const directory = params?.directory || router.currentRoute.value?.params.directory;
    const monitoringId = router.currentRoute.value?.params.monitoringId;
    return await http.post(`/event/${directory}/history${monitoringId ? '/' + monitoringId : ''}`, {
      ...params,
    }).then((response) => response?.data)
    .catch((err) => ({
      ...err,
    }));
  },
  async getStatusExportCsv(_, id) {
    const directory = router.currentRoute.value?.params.directory;
    const monitoringId = router.currentRoute.value?.params.monitoringId;
    const urlApi = monitoringId && directory ? `export/status/${directory}/${id}/${monitoringId}` : `export/status/${id}`;
    return await http.post(urlApi).then((response) => {
      return response?.data;
    });
  },
};
